import n from 'normalize-data'
/**
 * Used at createJob, getJob, updateJob and closeJob
 * @param {*} jobReq
 */
export const jobReq = (jobReq) =>
  n.normalize(
    jobReq,
    [
      // ['slug', 'id', (id) => slugify(id, { remove: /\//g })]
      // ['slug', 'id', (id) => slugify(id, { remove: /[*+~.()'"!:@]/g })]
    ],
    true
  )
